import { Snackbar, Alert, AlertTitle, CircularProgress, Typography } from '@mui/material'
import { useStatus } from '../context'

export const GenerationStatusModal = () => {
    const { status, resetStatus } = useStatus()
    const { message, errorDetails, isSummary, title: customTitle, severity: customSeverity } = status

    const isBusy = status.status === 'generating' || status.status === 'uploading' || status.status === 'loading'
    const open = status.status !== 'idle'
    // Duración de visualización: null para estados en progreso, 6s para error, 4s para otros
    const autoHideDuration = open ? (isBusy ? null : (status.status === 'error' ? 6000 : 4000)) : null

    const severity = customSeverity || (status.status === 'error' ? 'error' : (status.status === 'completed' || status.status === 'success' ? 'success' : 'info'))

    let title = customTitle
    let explainedMessage = message

    if (status.status === 'error' && errorDetails) {
        const code = String(errorDetails.code || '')
        if (code === '400') {
            title = title || 'Solicitud Incorrecta (400)'
            explainedMessage = explainedMessage || 'Los datos enviados no son válidos. Verifique si faltan archivos en la carga o si la carpeta seleccionada es correcta.'
        } else if (code === '404') {
            title = title || 'Recurso No Encontrado (404)'
            explainedMessage = explainedMessage || 'El archivo o paso solicitado no existe o fue eliminado previamente.'
        } else if (code === '500') {
            title = title || 'Error Interno del Servidor (500)'
            explainedMessage = explainedMessage || 'Ocurrió un error general en el servidor. Intente nuevamente en unos momentos.'
        } else if (code.toLowerCase() === 'cliente' || code === 'ERR_NETWORK') {
            title = title || 'Error de Red / Conexión'
            explainedMessage = explainedMessage || 'No se pudo establecer comunicación con el servidor. Verifica tu conexión a internet o el estado del backend.'
        } else {
            title = title || `Error (${code})`
        }
    }

    if (!title) {
        if (status.status === 'generating') {
            title = isSummary ? 'Generando Sumario...' : 'Generando Reporte OT...'
        } else if (status.status === 'uploading') {
            title = 'Subiendo archivo...'
        } else if (status.status === 'completed' || status.status === 'success') {
            title = isSummary ? 'Sumario Generado' : 'Operación Completada'
        } else {
            title = 'Notificación de Estado'
        }
    }

    return (
        <Snackbar
            open={open}
            onClose={(event, reason) => {
                if (reason === 'clickaway') {
                    return
                }
                resetStatus()
            }}
            autoHideDuration={autoHideDuration}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        >
            <Alert
                onClose={resetStatus}
                severity={severity}
                icon={isBusy ? <CircularProgress size={20} color="inherit" /> : null}
                sx={{
                    width: '100%',
                    boxShadow: 6,
                    minWidth: '300px',
                    maxWidth: '500px',
                    '.MuiAlert-message': { width: '100%' },
                    ...(severity === 'warning' && { bgcolor: '#fff9c4', color: '#827717' }),
                    ...(severity === 'info' && { bgcolor: '#e3f2fd', color: '#0d47a1' })
                }}
            >
                <AlertTitle sx={{ fontWeight: 'bold' }}>{title}</AlertTitle>
                <Typography variant="body2">{explainedMessage}</Typography>
                {status.status === 'generating' && (
                    <Typography variant="caption" display="block" sx={{ mt: 0.5, fontStyle: 'italic', opacity: 0.85 }}>
                        Por favor espere, este proceso puede tomar un momento.
                    </Typography>
                )}
                {status.status === 'uploading' && (
                    <Typography variant="caption" display="block" sx={{ mt: 0.5, fontStyle: 'italic', opacity: 0.85 }}>
                        Subiendo imagen, por favor espere...
                    </Typography>
                )}
                {status.status === 'error' && errorDetails && (
                    <Typography variant="caption" display="block" sx={{ mt: 1, wordBreak: 'break-word', opacity: 0.8 }}>
                        {`Código: ${errorDetails.code || 'N/A'}`}<br />
                        {`Detalle Técnico: ${errorDetails.info || 'No hay más información.'}`}
                    </Typography>
                )}
            </Alert>
        </Snackbar>
    )
}
